import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=40a4e00b&scoped=true&"
import script from "./DashboardCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=40a4e00b&lang=less&scoped=true&"
import style1 from "./DashboardCard.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4e00b",
  null
  
)

export default component.exports